module.exports = __webpack_public_path__ + "img/tuto_internet_way_01_05.0f69848b.png";